import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentPlayFilled: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M8.325 3.297C6.826 2.482 5 3.567 5 5.274v13.452c0 1.706 1.826 2.792 3.325 1.976l12.362-6.726c1.566-.852 1.566-3.1 0-3.953L8.325 3.297z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentPlayFilled
